export const ROUTE_CLUB_ROOT = '/clubs';
export const ROUTE_CLUB_EDIT = ROUTE_CLUB_ROOT + '/edit/:id';
export const ROUTE_CLUB_NEW = ROUTE_CLUB_ROOT + '/new';



// WEBPACK FOOTER //
// ./src/components/Clubs/constants.js